import { useEffect, useState } from "react";
import { Col, Row, Card, Table, Button, Form } from "react-bootstrap";
import onchlyService from "services/onchly.service";
import Pagination from "components/Util/Pagination";
import moment from "moment";
import Loading from "components/Util/Loading";

export default function Onchly(props) {
  const [profile, setProfile] = useState("");

  const [users, setUsers] = useState();

  const [sections, setSections] = useState({
    list: [],
    paginations: {
      limit: 10,
      offset: 0,
      count: 0,
    },
    loading: false,
  });
  const [notifications, setNotifications] = useState({
    list: [],
    paginations: {
      limit: 10,
      offset: 0,
      count: 0,
    },
    loading: false,
  });
  const [surveys, setSurveys] = useState({
    list: [],
    paginations: {
      limit: 10,
      offset: 0,
      count: 0,
    },
    loading: false,
  });
  const [segments, setSegments] = useState({
    list: [],
    paginations: {
      limit: 10,
      offset: 0,
      count: 0,
    },
    loading: false,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (props.consumer) {
      getProfile(props.consumer.registration_number);
    }
  }, [props?.consumer]);

  const getProfile = async (registration_number) => {
    try {
      setLoading(true);
      const response = await onchlyService.getProfile(`${registration_number}`);
      // console.log(response.data.id);
      setProfile(response.data);

      setProfile(response.data);
      getSections(response.data.id);
      getSurveys(response.data.id);
      getNotifications(response.data.id);
      getSegments(response.data.id);
      getUsers(response.data.id);
    } catch (err) {
      props.notify("tr", "danger", "Profile татахад алдаа гарлаа.");
    } finally {
      setLoading(false);
    }
  };
  const getSections = async (id) => {
    try {
      const response = await onchlyService.getSections(id);
      setSections((prev) => ({
        ...prev,
        list: response.data,
      }));
    } catch (err) {}
  };
  const getSurveys = async (id) => {
    try {
      const response = await onchlyService.getSurveys(id);
      setSurveys((prev) => ({
        ...prev,
        list: response.data,
      }));
    } catch (err) {}
  };
  const getNotifications = async (id) => {
    try {
      const response = await onchlyService.getNotifications(id);
      setNotifications((prev) => ({
        ...prev,
        list: response.data,
      }));
    } catch (err) {}
  };
  //dangerously
  const getSegments = async (id) => {
    try {
      // const response = await onchlyService.getSegments(id);
      // setSegments((prev) => ({
      //   ...prev,
      //   list: response.data,
      // }));
    } catch (err) {}
  };
  const getUsers = async (id) => {
    try {
      const response = await onchlyService.getUsers(id);
      setUsers((prev) => ({
        ...prev,
        list: response.data,
      }));
    } catch (err) {}
  };
  return (
    <>
      <Col md="12">
        <Card className="striped-tabled-with-hover">
          <Loading loading={loading} />
          <Card.Header>
            <Card.Title as="h4">Хэрэглэгчийн мэдээлэл</Card.Title>
          </Card.Header>
          <Card.Body>
            <Row>
              <Col md="12">
                <Table
                  className="table-hover"
                  style={{
                    fontSize: "12px",
                  }}
                >
                  <thead>
                    <tr>
                      <th className="border-0">Овог</th>
                      <th className="border-0">Нэр</th>
                      <th className="border-0">Төлөв</th>
                      <th className="border-0">Код</th>
                      <th className="border-0">Profile</th>
                      <th className="border-0">Upoint connected</th>
                      <th className="border-0">Upoint connected Date</th>
                      <th className="border-0">Term accepted</th>
                      <th className="border-0">Term accepted Date</th>
                      <th className="border-0">Prosur accepted</th>
                      <th className="border-0">Prosur accepted Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      <tr>
                        <td>{profile?.lastName}</td>
                        <td>{profile?.firstName}</td>
                        <td>{profile?.activeStatus}</td>
                        <td>{profile?.code}</td>
                        <td>{profile?.withProfile?.toString()}</td>
                        <td>{profile?.upointIsConnected?.toString()}</td>
                        <td>
                          {profile?.upointConnectedDate
                            ? moment(profile?.upointConnectedDate).format(
                                "YYYY-MM-DD HH:mm"
                              )
                            : ""}
                        </td>
                        <td>{profile?.termIsAccepted?.toString()}</td>
                        <td>
                          {profile?.termAcceptedDate
                            ? moment(profile?.termAcceptedDate).format(
                                "YYYY-MM-DD HH:mm"
                              )
                            : ""}
                        </td>
                        <td>{profile?.prosurIsAccepted?.toString()}</td>
                        <td>
                          {profile?.prosurAcceptedDate
                            ? moment(profile?.prosurAcceptedDate).format(
                                "YYYY-MM-DD HH:mm"
                              )
                            : ""}
                        </td>
                      </tr>
                    }
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>

      <Col md="12">
        <Card className="striped-tabled-with-hover">
          <Card.Header>
            <Card.Title as="h4">Хэрэглэгчийн мэдээлэл</Card.Title>
          </Card.Header>
          <Card.Body>
            <Row>
              <Col md="8">
                <Table
                  className="table-hover"
                  style={{
                    fontSize: "12px",
                  }}
                >
                  <thead>
                    <tr>
                      <th className="border-0">№</th>
                      <th className="border-0">Id</th>
                      <th className="border-0">Үүссэн Огноо</th>
                      <th className="border-0">Судалгаа</th>
                      <th className="border-0">Төлөв</th>
                      <th className="border-0">Бөглөсөн Огноо</th>
                      <th className="border-0">UPoint Оноо</th>
                      <th className="border-0">Урамшуулал Авсан Огноо</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sections.list?.map((section) => {
                      return (
                        <tr>
                          <td>{section.sectionOrder}</td>
                          <td>
                            {moment(section.createdAt).format(
                              "YYYY-MM-DD HH:mm"
                            )}
                          </td>
                          <td>{section.id}</td>
                          <td>{section.title}</td>
                          <td>{section.activeStatus}</td>
                          <td>{section.completedAt}</td>
                          <td>{section.sentUpoint}</td>
                          <td>{section.sentUpointAt}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
      <Col md="12">
        <Card className="striped-tabled-with-hover">
          <Card.Header>
            <Card.Title as="h4">Судалгаа</Card.Title>
          </Card.Header>
          <Card.Body>
            <Row>
              <Col md="12">
                <Table
                  className="table-hover"
                  style={{
                    fontSize: "12px",
                  }}
                >
                  <thead>
                    <tr>
                      <th className="border-0">Id</th>
                      <th className="border-0">Үүссэн Огноо</th>
                      <th className="border-0">Судалгаа</th>
                      <th className="border-0">Төлөв</th>
                      <th className="border-0">Дэлгэрэнгүй</th>
                      <th className="border-0">Хугацаа</th>
                      <th className="border-0">Эхлэх Огноо</th>
                      <th className="border-0">Дуусах Огноо</th>
                      <th className="border-0">Хаах Огноо</th>
                      {/* <th className="border-0">Нийт</th> */}
                      {/* <th className="border-0">Бөглөсөн</th> */}
                      <th className="border-0">Шагналын Оноо</th>
                      {/* <th className="border-0">Шагнал Төрөл</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {surveys.list?.map((survey) => {
                      return (
                        <tr>
                          <td>{survey.id}</td>
                          <td>
                            {moment(survey.createdAt).format(
                              "YYYY-MM-DD HH:mm"
                            )}
                          </td>
                          <td>{survey?.requestTask?.requestSurvey?.title}</td>
                          <td>{survey?.activeStatus}</td>
                          <td>
                            {survey?.requestTask?.requestSurvey?.description}
                          </td>
                          <td>
                            {
                              survey?.requestTask?.requestSurvey
                                ?.completionTimeUiText
                            }
                          </td>
                          <td>{survey?.requestTask?.startDate}</td>
                          <td>{survey?.requestTask?.endDate}</td>
                          <td>{survey?.requestTask?.closeDate}</td>
                          {/* <td>{survey?.requestTask?.totalQuote}</td> */}
                          {/* <td>{survey?.survey?.totalProgressCount}</td> */}
                          <td>
                            {survey?.requestTask?.requestSurvey?.prizeValue}
                          </td>
                          {/* <td>
                            {survey?.requestTask?.requestSurvey?.prizeType}
                          </td> */}
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
      <Col md="8">
        <Card className="striped-tabled-with-hover">
          <Card.Header>
            <Card.Title as="h4">Notifications</Card.Title>
          </Card.Header>
          <Card.Body>
            <Row>
              <Col md="12">
                <Table
                  className="table-hover"
                  style={{
                    fontSize: "12px",
                  }}
                >
                  <thead>
                    <tr>
                      <th className="border-0">Id</th>
                      <th className="border-0">Үүссэн Огноо</th>
                      <th className="border-0">Судалгаа</th>
                      <th className="border-0">Төлөв</th>
                      <th className="border-0">Дэлгэрэнгүй</th>
                      <th className="border-0">Төрөл</th>
                      <th className="border-0">Харсан</th>
                      <th className="border-0">Уншсан</th>
                    </tr>
                  </thead>
                  <tbody>
                    {notifications.list?.map((noti) => {
                      return (
                        <tr>
                          <td>{noti.id}</td>
                          <td>
                            {moment(noti.createdAt).format("YYYY-MM-DD HH:mm")}
                          </td>
                          <td>{noti.notification.title}</td>
                          <td>{noti.notification.activeStatus}</td>
                          <td>{noti.notification.description}</td>
                          <td>{noti.notification.notificationType}</td>
                          <td>{noti.isShow?.toString()}</td>
                          <td>{noti.isRead?.toString()}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>

      {/* <Col md="8">
        <Card className="striped-tabled-with-hover">
          <Card.Header>
            <Card.Title as="h4">Segments</Card.Title>
          </Card.Header>
          <Card.Body>
            <Row>
              <Col md="12">
                <Table
                  className="table-hover"
                  style={{
                    fontSize: "12px",
                  }}
                >
                  <thead>
                    <tr>
                      <th className="border-0">Id</th>
                      <th className="border-0">Үүссэн Огноо</th>
                      <th className="border-0">Нэр</th>
                      <th className="border-0">Төлөв</th>
                      <th className="border-0">Дэлгэрэнгүй</th>
                      <th className="border-0">Утга</th>
                    </tr>
                  </thead>
                  <tbody>
                    {segments.list?.map((segment) => {
                      return (
                        <tr>
                          <td>{segment.id}</td>
                          <td>
                            {moment(segment.createdAt).format(
                              "YYYY-MM-DD HH:mm"
                            )}
                          </td>
                          <td>{segment.segment.name}</td>
                          <td>{segment.activeStatus}</td>
                          <td>{segment.segment.description}</td>
                          <td>{segment.valueText}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col> */}
    </>
  );
}
